export default __webpack_public_path__ + "resources/icons/d112-dd3a.png";